var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gachi-search2",attrs:{"data-search":"results"}},[_c('search',{attrs:{"search-data":_vm.getSearch}}),_c('div',{staticClass:"search-results"},[_c('results',{attrs:{"headers":_vm.headers,"items":_vm.items}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }